import { render, staticRenderFns } from "./NotificationsCustomDialog.vue?vue&type=template&id=4e1e22ae&scoped=true"
import script from "./NotificationsCustomDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsCustomDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationsCustomDialog.vue?vue&type=style&index=0&id=4e1e22ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e22ae",
  null
  
)

export default component.exports